const events = {
  SCROLL: 'list_scrolling',
  SET_DATA: 'list_set_data',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/classes/list/events.js